import { type AxiosInstance } from "axios";

import type {
  CreateLocationPrecisionOverrideRequestUnbranded,
  LocationPrecisionOverrideUnbranded,
  UpdateLocationPrecisionOverrideRequestUnbranded,
} from "./locationPrecisionOverride.js";

export type GetLocationPrecisionOverridesResponse =
  LocationPrecisionOverrideUnbranded[];

export type SearchLocationPrecisionOverridesResponse = {
  results: LocationPrecisionOverrideUnbranded[];
  count: number;
};

export const locationPrecisionOverrideConfig = {
  getAll: () => ({
    url: `/api/location-precision-override/`,
    method: "get" as const,
  }),
  search: (query: string, limit: number, offset: number) => ({
    url: `/api/location-precision-override/search`,
    method: "get" as const,
    params: { query, limit, offset },
  }),
  getById: (id: string) => ({
    url: `/api/location-precision-override/${id}`,
    method: "get" as const,
  }),
  create: (
    id: string,
    request: CreateLocationPrecisionOverrideRequestUnbranded,
  ) => ({
    url: `/api/location-precision-override/${id}`,
    method: "put" as const,
    data: request,
  }),
  update: (
    id: string,
    request: UpdateLocationPrecisionOverrideRequestUnbranded,
  ) => ({
    url: `/api/location-precision-override/${id}`,
    method: "post" as const,
    data: request,
  }),
  delete: (id: string) => ({
    url: `/api/location-precision-override/${id}`,
    method: "delete" as const,
  }),
};

export const locationPrecisionOverrideRequests = (apiAxios: AxiosInstance) => {
  return {
    locationPrecisionOverride: {
      getAll: () =>
        apiAxios.request<GetLocationPrecisionOverridesResponse>(
          locationPrecisionOverrideConfig.getAll(),
        ),
      search: (query: string, limit: number, offset: number) =>
        apiAxios.request<SearchLocationPrecisionOverridesResponse>(
          locationPrecisionOverrideConfig.search(query, limit, offset),
        ),
      getById: (id: string) =>
        apiAxios.request<LocationPrecisionOverrideUnbranded>(
          locationPrecisionOverrideConfig.getById(id),
        ),
      create: (
        id: string,
        request: CreateLocationPrecisionOverrideRequestUnbranded,
      ) =>
        apiAxios.request<LocationPrecisionOverrideUnbranded>(
          locationPrecisionOverrideConfig.create(id, request),
        ),
      update: (
        id: string,
        request: UpdateLocationPrecisionOverrideRequestUnbranded,
      ) =>
        apiAxios.request<LocationPrecisionOverrideUnbranded>(
          locationPrecisionOverrideConfig.update(id, request),
        ),
      delete: (id: string) =>
        apiAxios.request<undefined>(locationPrecisionOverrideConfig.delete(id)),
    },
  };
};
